import { ProList } from '@ant-design/pro-components'
import type { PatientFindingView } from '@app/icare/entities/patientFinding/schema/PatientFinding'
import { PATIENT_FINDINGS_CONFIG } from '@app/icare/entities/patientFinding/schema/PatientFinding.config'
import { t } from '@lingui/core/macro'
import { twMerge } from 'tailwind-merge'

interface FindingsMessagesProps {
  findings?: PatientFindingView[]
  className?: string
}

export function FindingsMessages(props: FindingsMessagesProps) {
  const { className, findings } = props

  if (!findings || findings.length === 0) {
    return null
  }

  return (
    <ProList
      className={twMerge(className)}
      itemRender={({ findingId }) => t(PATIENT_FINDINGS_CONFIG[findingId].message)}
      rowKey="id"
      size="small"
      ghost
      split
      dataSource={findings}
    />
  )
}
